import http from "@/services/http";
import {ref} from 'vue';
import {useAuth} from "@/services/auth.js";

export const agendamentos = () => {
  const auth = useAuth();
  // Mensagem real do erro (ex.: sem permissão pra mexer na agenda) — usado
  // quando um orçamento tenta agendar visita, ver PdvView.vue.
  const lastErrorMessage = ref(null);

  async function create(agendamento) {
    try {
      const {data} = await http.post('/appointments', agendamento, auth.getBearer());
      lastErrorMessage.value = null;
      return data.data;
    } catch (error) {
      lastErrorMessage.value = error?.response?.data?.message ?? null;
      console.log(error?.response?.data);
      return false;
    }
  }

  return {create, lastErrorMessage}
}
